'use strict';

exports.CONNECT_LAYOUT = void 0;
(function (CONNECT_LAYOUT) {
    CONNECT_LAYOUT["CENTER"] = "center";
    CONNECT_LAYOUT["LEFT"] = "left";
    CONNECT_LAYOUT["RIGHT"] = "right";
})(exports.CONNECT_LAYOUT || (exports.CONNECT_LAYOUT = {}));
exports.CONNECT_BORDER_STYLES = void 0;
(function (CONNECT_BORDER_STYLES) {
    CONNECT_BORDER_STYLES["SOLID"] = "solid";
    CONNECT_BORDER_STYLES["DASHED"] = "dashed";
    CONNECT_BORDER_STYLES["NONE"] = "none";
})(exports.CONNECT_BORDER_STYLES || (exports.CONNECT_BORDER_STYLES = {}));
exports.CONNECT_BORDER_RADIUS = void 0;
(function (CONNECT_BORDER_RADIUS) {
    CONNECT_BORDER_RADIUS["ROUNDED"] = "rounded";
    CONNECT_BORDER_RADIUS["SQUARE"] = "square";
    CONNECT_BORDER_RADIUS["PILL"] = "pill";
})(exports.CONNECT_BORDER_RADIUS || (exports.CONNECT_BORDER_RADIUS = {}));
exports.CONNECT_SHADOW_TYPE = void 0;
(function (CONNECT_SHADOW_TYPE) {
    CONNECT_SHADOW_TYPE["LIGHT"] = "light";
    CONNECT_SHADOW_TYPE["DARK"] = "dark";
    CONNECT_SHADOW_TYPE["NONE"] = "none";
})(exports.CONNECT_SHADOW_TYPE || (exports.CONNECT_SHADOW_TYPE = {}));
exports.CONNECT_IMPLEMENTATION = void 0;
(function (CONNECT_IMPLEMENTATION) {
    CONNECT_IMPLEMENTATION["HOSTED"] = "hosted";
    CONNECT_IMPLEMENTATION["EMBEDDED"] = "embedded";
    CONNECT_IMPLEMENTATION["HOSTED_APP"] = "hosted-app";
    CONNECT_IMPLEMENTATION["EMBEDDED_APP"] = "embedded-app";
})(exports.CONNECT_IMPLEMENTATION || (exports.CONNECT_IMPLEMENTATION = {}));

exports.LOCALES = void 0;
(function (LOCALES) {
    LOCALES["ALBANIA"] = "al";
    LOCALES["ALGERIA"] = "dz";
    LOCALES["ANTIGUA_AND_BARBUDA"] = "ag";
    LOCALES["ARGENTINA"] = "ar";
    LOCALES["ARMENIA"] = "am";
    LOCALES["AUSTRALIA"] = "au";
    LOCALES["AUSTRIA"] = "at";
    LOCALES["AZERBAIJAN"] = "az";
    LOCALES["BAHAMAS"] = "bs";
    LOCALES["BAHRAIN"] = "bh";
    LOCALES["BANGLADESH"] = "bd";
    LOCALES["BELARUS"] = "by";
    LOCALES["BELGIUM"] = "be";
    LOCALES["BRAZIL"] = "br";
    LOCALES["BULGARIA"] = "bg";
    LOCALES["CAMBODIA"] = "kh";
    LOCALES["CANADA"] = "ca";
    LOCALES["CHILE"] = "cl";
    LOCALES["CHINA"] = "cn";
    LOCALES["COLOMBIA"] = "co";
    LOCALES["COSTA_RICA"] = "cr";
    LOCALES["CROATIA"] = "hr";
    LOCALES["CYPRUS"] = "cy";
    LOCALES["CZECH_REPUBLIC"] = "cz";
    LOCALES["DENMARK"] = "dk";
    LOCALES["DOMINICAN_REPUBLIC"] = "do";
    LOCALES["ECUADOR"] = "ec";
    LOCALES["EGYPT"] = "eg";
    LOCALES["EL_SALVADOR"] = "sv";
    LOCALES["ESTONIA"] = "ee";
    LOCALES["FIJI"] = "fj";
    LOCALES["FINLAND"] = "fi";
    LOCALES["FRANCE"] = "fr";
    LOCALES["GERMANY"] = "de";
    LOCALES["GHANA"] = "gh";
    LOCALES["GREECE"] = "gr";
    LOCALES["GUATEMALA"] = "gt";
    LOCALES["HONDURAS"] = "hn";
    LOCALES["HONG_KONG"] = "hk";
    LOCALES["HUNGARY"] = "hu";
    LOCALES["INDIA"] = "in";
    LOCALES["INDONESIA"] = "id";
    LOCALES["IRAN"] = "ir";
    LOCALES["IRELAND"] = "ie";
    LOCALES["ISRAEL"] = "il";
    LOCALES["ITALY"] = "it";
    LOCALES["JAMAICA"] = "jm";
    LOCALES["JAPAN"] = "jp";
    LOCALES["JORDAN"] = "jo";
    LOCALES["KAZAKHSTAN"] = "kz";
    LOCALES["KENYA"] = "ke";
    LOCALES["KUWAIT"] = "kw";
    LOCALES["KYRGYZSTAN"] = "kg";
    LOCALES["LATVIA"] = "lv";
    LOCALES["LEBANON"] = "lb";
    LOCALES["LITHUANIA"] = "lt";
    LOCALES["LUXEMBOURG"] = "lu";
    LOCALES["MACAU"] = "mo";
    LOCALES["MALAYSIA"] = "my";
    LOCALES["MALTA"] = "mt";
    LOCALES["MAURITIUS"] = "mu";
    LOCALES["MEXICO"] = "mx";
    LOCALES["MOLDOVA"] = "md";
    LOCALES["NETHERLANDS"] = "nl";
    LOCALES["NEW_ZEALAND"] = "nz";
    LOCALES["NIGERIA"] = "ng";
    LOCALES["NORWAY"] = "no";
    LOCALES["OMAN"] = "om";
    LOCALES["PAKISTAN"] = "pk";
    LOCALES["PANAMA"] = "pa";
    LOCALES["PARAGUAY"] = "py";
    LOCALES["PERU"] = "pe";
    LOCALES["PHILIPPINES"] = "ph";
    LOCALES["POLAND"] = "pl";
    LOCALES["PORTUGAL"] = "pt";
    LOCALES["QATAR"] = "qa";
    LOCALES["REPUBLIC_OF_NORTH_MACEDONIA"] = "mk";
    LOCALES["REPUBLIC_OF_MONGOLIA"] = "mn";
    LOCALES["ROMANIA"] = "ro";
    LOCALES["RUSSIA"] = "ru";
    LOCALES["SAUDI_ARABIA"] = "sa";
    LOCALES["SINGAPORE"] = "sg";
    LOCALES["SLOVAKIA"] = "sk";
    LOCALES["SLOVENIA"] = "si";
    LOCALES["SOUTH_AFRICA"] = "za";
    LOCALES["SOUTH_KOREA"] = "kr";
    LOCALES["SPAIN"] = "es";
    LOCALES["SRI_LANKA"] = "lk";
    LOCALES["SWEDEN"] = "se";
    LOCALES["SWITZERLAND"] = "ch";
    LOCALES["TAIWAN"] = "tw";
    LOCALES["TANZANIA"] = "tz";
    LOCALES["THAILAND"] = "th";
    LOCALES["TRINIDAD_AND_TOBAGO"] = "tt";
    LOCALES["TUNISIA"] = "tn";
    LOCALES["TURKEY"] = "tr";
    LOCALES["UKRAINE"] = "ua";
    LOCALES["UNITED_ARAB_EMIRATES"] = "ae";
    LOCALES["UNITED_KINGDOM"] = "uk";
    LOCALES["UNITED_STATES"] = "us";
    LOCALES["VENEZUELA"] = "ve";
    LOCALES["VIETNAM"] = "vn";
    LOCALES["VIRGIN_ISLANDS_BRITISH"] = "vg";
    LOCALES["ZIMBABWE"] = "zw";
})(exports.LOCALES || (exports.LOCALES = {}));
const DEFAULT_LOCALE = 'en';
const DEFAULT_ZENDESK = 'en-us';
const DEFAULT_COUNTRY = {
    code: exports.LOCALES.UNITED_KINGDOM,
    fallback: '',
    fullSupport: false,
    hasApp: false,
    hasBrowserExtension: false,
    hasCountryLink: false,
    hasGraduate: false,
    hasBeansId: false,
    hasKevelPromoBoxes: false,
    hasZendeskChat: false,
    htmlLang: 'en',
    isEnglishSpeaking: true,
    locale: DEFAULT_LOCALE,
    zendesk: DEFAULT_ZENDESK,
    currency: 'GBP'
};
const COUNTRIES = {
    [exports.LOCALES.ALBANIA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Albania', code: exports.LOCALES.ALBANIA }),
    [exports.LOCALES.ALGERIA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Algeria', code: exports.LOCALES.ALGERIA }),
    [exports.LOCALES.ANTIGUA_AND_BARBUDA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Antigua and Barbuda', code: exports.LOCALES.ANTIGUA_AND_BARBUDA }),
    [exports.LOCALES.ARGENTINA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Argentina', code: exports.LOCALES.ARGENTINA }),
    [exports.LOCALES.ARMENIA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Armenia', code: exports.LOCALES.ARMENIA }),
    [exports.LOCALES.AUSTRALIA]: {
        code: exports.LOCALES.AUSTRALIA,
        fallback: 'Australia',
        fullSupport: true,
        hasApp: true,
        hasBrowserExtension: true,
        hasCountryLink: true,
        nativeName: 'Australia',
        hasGraduate: true,
        hasBeansId: true,
        hasKevelPromoBoxes: true,
        hasZendeskChat: false,
        htmlLang: 'en-au',
        isEnglishSpeaking: true,
        locale: 'en',
        zendesk: DEFAULT_ZENDESK,
        currency: 'AUD'
    },
    [exports.LOCALES.AUSTRIA]: {
        code: exports.LOCALES.AUSTRIA,
        fallback: 'Austria',
        fullSupport: true,
        hasApp: true,
        hasBrowserExtension: true,
        hasCountryLink: true,
        nativeName: 'Österreich',
        hasGraduate: false,
        hasBeansId: false,
        hasKevelPromoBoxes: false,
        hasZendeskChat: false,
        htmlLang: 'de-at',
        isEnglishSpeaking: false,
        locale: 'de',
        zendesk: DEFAULT_ZENDESK,
        currency: 'EUR'
    },
    [exports.LOCALES.AZERBAIJAN]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Azerbaijan', code: exports.LOCALES.AZERBAIJAN }),
    [exports.LOCALES.BAHAMAS]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Bahamas', code: exports.LOCALES.BAHAMAS }),
    [exports.LOCALES.BAHRAIN]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Bahrain', code: exports.LOCALES.BAHRAIN }),
    [exports.LOCALES.BANGLADESH]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Bangladesh', code: exports.LOCALES.BANGLADESH }),
    [exports.LOCALES.BELARUS]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Belarus', code: exports.LOCALES.BELARUS }),
    [exports.LOCALES.BELGIUM]: {
        code: exports.LOCALES.BELGIUM,
        fallback: 'Belgium',
        fullSupport: true,
        hasApp: true,
        hasBrowserExtension: true,
        hasCountryLink: true,
        nativeName: 'België',
        hasGraduate: false,
        hasBeansId: false,
        hasKevelPromoBoxes: false,
        hasZendeskChat: false,
        htmlLang: 'nl-be',
        isEnglishSpeaking: false,
        locale: 'nl',
        zendesk: 'nl-be',
        currency: 'EUR'
    },
    [exports.LOCALES.BRAZIL]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Brazil', code: exports.LOCALES.BRAZIL, htmlLang: 'pt-br', locale: exports.LOCALES.BRAZIL }),
    [exports.LOCALES.BULGARIA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Bulgaria', code: exports.LOCALES.BULGARIA }),
    [exports.LOCALES.CAMBODIA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Cambodia', code: exports.LOCALES.CAMBODIA }),
    [exports.LOCALES.CANADA]: {
        code: exports.LOCALES.CANADA,
        fallback: 'Canada',
        fullSupport: true,
        hasApp: true,
        hasBrowserExtension: true,
        hasCountryLink: true,
        nativeName: 'Canada',
        hasGraduate: true,
        hasBeansId: true,
        hasKevelPromoBoxes: true,
        hasZendeskChat: false,
        htmlLang: 'en-ca',
        isEnglishSpeaking: true,
        locale: 'en',
        zendesk: 'en-us',
        currency: 'CAD'
    },
    [exports.LOCALES.CHILE]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Chile', code: exports.LOCALES.CHILE }),
    [exports.LOCALES.CHINA]: {
        code: exports.LOCALES.CHINA,
        fallback: 'China',
        fullSupport: true,
        hasApp: true,
        hasBrowserExtension: true,
        hasCountryLink: true,
        nativeName: '中国',
        hasGraduate: false,
        hasBeansId: false,
        hasKevelPromoBoxes: false,
        hasZendeskChat: false,
        htmlLang: 'zh-cn',
        isEnglishSpeaking: false,
        locale: 'zh-Hans',
        zendesk: 'zh-cn',
        currency: 'CNY'
    },
    [exports.LOCALES.COLOMBIA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Colombia', code: exports.LOCALES.COLOMBIA }),
    [exports.LOCALES.COSTA_RICA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Costa Rica', code: exports.LOCALES.COSTA_RICA }),
    [exports.LOCALES.CROATIA]: {
        code: exports.LOCALES.CROATIA,
        fallback: 'Croatia',
        fullSupport: false,
        hasApp: false,
        hasBrowserExtension: false,
        hasCountryLink: false,
        hasGraduate: false,
        hasBeansId: false,
        hasKevelPromoBoxes: false,
        hasZendeskChat: false,
        htmlLang: 'hr-hr',
        isEnglishSpeaking: false,
        locale: DEFAULT_LOCALE,
        zendesk: DEFAULT_ZENDESK,
        currency: 'HRK'
    },
    [exports.LOCALES.CYPRUS]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Cyprus', code: exports.LOCALES.CYPRUS }),
    [exports.LOCALES.CZECH_REPUBLIC]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { code: exports.LOCALES.CZECH_REPUBLIC, fallback: 'Czech Republic', htmlLang: 'cs-cz' }),
    [exports.LOCALES.DENMARK]: {
        code: exports.LOCALES.DENMARK,
        fallback: 'Denmark',
        fullSupport: true,
        hasApp: true,
        hasBrowserExtension: true,
        hasCountryLink: true,
        nativeName: 'Danmark',
        hasGraduate: false,
        hasBeansId: false,
        hasKevelPromoBoxes: false,
        hasZendeskChat: false,
        htmlLang: 'da-dk',
        isEnglishSpeaking: false,
        locale: 'da',
        zendesk: 'da',
        currency: 'DKK'
    },
    [exports.LOCALES.DOMINICAN_REPUBLIC]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Dominican Republic', code: exports.LOCALES.DOMINICAN_REPUBLIC }),
    [exports.LOCALES.ECUADOR]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Ecuador', code: exports.LOCALES.ECUADOR }),
    [exports.LOCALES.EGYPT]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Egypt', code: exports.LOCALES.EGYPT }),
    [exports.LOCALES.EL_SALVADOR]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'El Salvador', code: exports.LOCALES.EL_SALVADOR }),
    [exports.LOCALES.ESTONIA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Estonia', code: exports.LOCALES.ESTONIA }),
    [exports.LOCALES.FIJI]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Fiji', code: exports.LOCALES.FIJI }),
    [exports.LOCALES.FINLAND]: {
        code: exports.LOCALES.FINLAND,
        fallback: 'Finland',
        fullSupport: true,
        hasApp: false,
        hasBrowserExtension: false,
        hasCountryLink: true,
        nativeName: 'Finland',
        hasGraduate: false,
        hasBeansId: false,
        hasKevelPromoBoxes: false,
        hasZendeskChat: false,
        htmlLang: 'fi-fi',
        isEnglishSpeaking: false,
        locale: 'fi',
        zendesk: DEFAULT_ZENDESK,
        currency: 'EUR'
    },
    [exports.LOCALES.FRANCE]: {
        code: exports.LOCALES.FRANCE,
        fallback: 'France',
        fullSupport: true,
        hasApp: true,
        hasBrowserExtension: true,
        hasCountryLink: true,
        nativeName: 'France',
        hasGraduate: false,
        hasBeansId: false,
        hasKevelPromoBoxes: true,
        hasZendeskChat: false,
        htmlLang: 'fr-fr',
        isEnglishSpeaking: false,
        locale: 'fr',
        zendesk: 'fr',
        currency: 'EUR'
    },
    [exports.LOCALES.GERMANY]: {
        code: exports.LOCALES.GERMANY,
        fallback: 'Germany',
        fullSupport: true,
        hasApp: true,
        hasBrowserExtension: true,
        hasCountryLink: true,
        nativeName: 'Deutschland',
        hasGraduate: false,
        hasBeansId: false,
        hasKevelPromoBoxes: true,
        hasZendeskChat: false,
        htmlLang: 'de-de',
        isEnglishSpeaking: false,
        locale: 'de',
        zendesk: 'de',
        currency: 'EUR'
    },
    [exports.LOCALES.GHANA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Ghana', code: exports.LOCALES.GHANA }),
    [exports.LOCALES.GREECE]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Greece', code: exports.LOCALES.GREECE }),
    [exports.LOCALES.GUATEMALA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Guatemala', code: exports.LOCALES.GUATEMALA }),
    [exports.LOCALES.HONDURAS]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Honduras', code: exports.LOCALES.HONDURAS }),
    [exports.LOCALES.HONG_KONG]: {
        code: exports.LOCALES.HONG_KONG,
        fallback: 'Hong Kong S.A.R.',
        fullSupport: true,
        hasApp: true,
        hasBrowserExtension: false,
        hasCountryLink: true,
        nativeName: '香港',
        hasGraduate: false,
        hasBeansId: false,
        hasKevelPromoBoxes: false,
        hasZendeskChat: false,
        htmlLang: 'zh-hk',
        isEnglishSpeaking: false,
        locale: 'zh-Hant',
        zendesk: DEFAULT_ZENDESK,
        currency: 'HKD'
    },
    [exports.LOCALES.HUNGARY]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Hungary', code: exports.LOCALES.HUNGARY }),
    [exports.LOCALES.INDIA]: {
        code: exports.LOCALES.INDIA,
        fallback: 'India',
        fullSupport: true,
        hasApp: false,
        hasBrowserExtension: false,
        hasCountryLink: true,
        nativeName: 'India',
        hasGraduate: false,
        hasBeansId: false,
        hasKevelPromoBoxes: false,
        hasZendeskChat: false,
        htmlLang: 'en-in',
        isEnglishSpeaking: true,
        locale: DEFAULT_LOCALE,
        zendesk: DEFAULT_ZENDESK,
        currency: 'INR'
    },
    [exports.LOCALES.INDONESIA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Indonesia', code: exports.LOCALES.INDONESIA }),
    [exports.LOCALES.IRAN]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Iran', code: exports.LOCALES.IRAN }),
    [exports.LOCALES.IRELAND]: {
        code: exports.LOCALES.IRELAND,
        fallback: 'Ireland',
        fullSupport: true,
        hasApp: true,
        hasBrowserExtension: true,
        hasCountryLink: true,
        nativeName: 'Ireland',
        hasGraduate: false,
        hasBeansId: true,
        hasKevelPromoBoxes: true,
        hasZendeskChat: false,
        htmlLang: 'en-ie',
        isEnglishSpeaking: true,
        locale: 'en',
        zendesk: DEFAULT_ZENDESK,
        currency: 'EUR'
    },
    [exports.LOCALES.ISRAEL]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Israel', code: exports.LOCALES.ISRAEL }),
    [exports.LOCALES.ITALY]: {
        code: exports.LOCALES.ITALY,
        fallback: 'Italy',
        fullSupport: true,
        hasApp: true,
        hasBrowserExtension: true,
        hasCountryLink: true,
        nativeName: 'Italia',
        hasGraduate: false,
        hasBeansId: false,
        hasKevelPromoBoxes: false,
        hasZendeskChat: false,
        htmlLang: 'it-it',
        isEnglishSpeaking: false,
        locale: 'it',
        zendesk: 'it',
        currency: 'EUR'
    },
    [exports.LOCALES.JAMAICA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Jamaica', code: exports.LOCALES.JAMAICA }),
    [exports.LOCALES.JAPAN]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Japan', code: exports.LOCALES.JAPAN, htmlLang: 'ja-jp' }),
    [exports.LOCALES.JORDAN]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Jordan', code: exports.LOCALES.JORDAN }),
    [exports.LOCALES.KAZAKHSTAN]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Kazakhstan', code: exports.LOCALES.KAZAKHSTAN }),
    [exports.LOCALES.KENYA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Kenya', code: exports.LOCALES.KENYA }),
    [exports.LOCALES.KUWAIT]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Kuwait', code: exports.LOCALES.KUWAIT }),
    [exports.LOCALES.KYRGYZSTAN]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Kyrgyzstan', code: exports.LOCALES.KYRGYZSTAN }),
    [exports.LOCALES.LATVIA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Latvia', code: exports.LOCALES.LATVIA }),
    [exports.LOCALES.LEBANON]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Lebanon', code: exports.LOCALES.LEBANON }),
    [exports.LOCALES.LITHUANIA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Lithuania', code: exports.LOCALES.LITHUANIA }),
    [exports.LOCALES.LUXEMBOURG]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Luxembourg', code: exports.LOCALES.LUXEMBOURG }),
    [exports.LOCALES.MACAU]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Macau', code: exports.LOCALES.MACAU }),
    [exports.LOCALES.MALAYSIA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Malaysia', code: exports.LOCALES.MALAYSIA }),
    [exports.LOCALES.MALTA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Malta', code: exports.LOCALES.MALTA }),
    [exports.LOCALES.MAURITIUS]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Mauritius', code: exports.LOCALES.MAURITIUS }),
    [exports.LOCALES.MEXICO]: {
        code: exports.LOCALES.MEXICO,
        fallback: 'Mexico',
        fullSupport: true,
        hasApp: false,
        hasBrowserExtension: false,
        hasCountryLink: true,
        nativeName: 'Mexico',
        hasGraduate: false,
        hasBeansId: false,
        hasKevelPromoBoxes: false,
        hasZendeskChat: false,
        htmlLang: 'es-mx',
        isEnglishSpeaking: false,
        locale: 'es',
        zendesk: DEFAULT_ZENDESK,
        currency: 'MXN'
    },
    [exports.LOCALES.MOLDOVA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Moldova', code: exports.LOCALES.MOLDOVA }),
    [exports.LOCALES.NETHERLANDS]: {
        code: exports.LOCALES.NETHERLANDS,
        fallback: 'Netherlands',
        fullSupport: true,
        hasApp: true,
        hasBrowserExtension: true,
        hasCountryLink: true,
        nativeName: 'Nederland',
        hasGraduate: false,
        hasBeansId: false,
        hasKevelPromoBoxes: true,
        hasZendeskChat: false,
        htmlLang: 'nl-nl',
        isEnglishSpeaking: false,
        locale: 'nl',
        zendesk: 'nl',
        currency: 'EUR'
    },
    [exports.LOCALES.NEW_ZEALAND]: {
        code: exports.LOCALES.NEW_ZEALAND,
        fallback: 'New Zealand',
        fullSupport: true,
        hasApp: true,
        hasBrowserExtension: true,
        hasCountryLink: true,
        nativeName: 'New Zealand',
        hasGraduate: true,
        hasBeansId: false,
        hasKevelPromoBoxes: false,
        hasZendeskChat: false,
        htmlLang: 'en-nz',
        isEnglishSpeaking: true,
        locale: 'en',
        zendesk: DEFAULT_ZENDESK,
        currency: 'NZD'
    },
    [exports.LOCALES.NIGERIA]: {
        code: exports.LOCALES.NIGERIA,
        fallback: 'Nigeria',
        fullSupport: true,
        hasApp: false,
        hasBrowserExtension: false,
        hasCountryLink: true,
        nativeName: 'Nigeria',
        hasGraduate: false,
        hasBeansId: false,
        hasKevelPromoBoxes: false,
        hasZendeskChat: false,
        htmlLang: 'en-ng',
        isEnglishSpeaking: true,
        locale: DEFAULT_LOCALE,
        zendesk: DEFAULT_ZENDESK,
        currency: 'NGN'
    },
    [exports.LOCALES.NORWAY]: {
        code: exports.LOCALES.NORWAY,
        fallback: 'Norway',
        fullSupport: true,
        hasApp: false,
        hasBrowserExtension: false,
        hasCountryLink: true,
        nativeName: 'Norway',
        hasGraduate: false,
        hasBeansId: false,
        hasKevelPromoBoxes: false,
        hasZendeskChat: false,
        htmlLang: 'no-no',
        isEnglishSpeaking: false,
        locale: 'nn',
        zendesk: DEFAULT_ZENDESK,
        currency: 'NOK'
    },
    [exports.LOCALES.OMAN]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Oman', code: exports.LOCALES.OMAN }),
    [exports.LOCALES.PAKISTAN]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Pakistan', code: exports.LOCALES.PAKISTAN }),
    [exports.LOCALES.PANAMA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Panama', code: exports.LOCALES.PANAMA }),
    [exports.LOCALES.PARAGUAY]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Paraguay', code: exports.LOCALES.PARAGUAY }),
    [exports.LOCALES.PERU]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Peru', code: exports.LOCALES.PERU }),
    [exports.LOCALES.PHILIPPINES]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Philippines', code: exports.LOCALES.PHILIPPINES }),
    [exports.LOCALES.POLAND]: {
        code: exports.LOCALES.POLAND,
        fallback: 'Poland',
        fullSupport: true,
        hasApp: true,
        hasBrowserExtension: true,
        hasCountryLink: true,
        nativeName: 'Polska',
        hasGraduate: false,
        hasBeansId: false,
        hasKevelPromoBoxes: false,
        hasZendeskChat: false,
        htmlLang: 'pl-pl',
        isEnglishSpeaking: false,
        locale: 'pl',
        zendesk: 'pl',
        currency: 'PLN'
    },
    [exports.LOCALES.PORTUGAL]: {
        code: exports.LOCALES.PORTUGAL,
        fallback: 'Portugal',
        fullSupport: true,
        hasApp: false,
        hasBrowserExtension: false,
        hasCountryLink: true,
        nativeName: 'Portugal',
        hasGraduate: false,
        hasBeansId: false,
        hasKevelPromoBoxes: false,
        hasZendeskChat: false,
        htmlLang: 'pt-pt',
        isEnglishSpeaking: false,
        locale: 'pt',
        zendesk: 'pt',
        currency: 'EUR'
    },
    [exports.LOCALES.QATAR]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Qatar', code: exports.LOCALES.QATAR }),
    [exports.LOCALES.REPUBLIC_OF_NORTH_MACEDONIA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Republic of North Macedonia', code: exports.LOCALES.REPUBLIC_OF_NORTH_MACEDONIA }),
    [exports.LOCALES.REPUBLIC_OF_MONGOLIA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Republic of Mongolia', code: exports.LOCALES.REPUBLIC_OF_MONGOLIA }),
    [exports.LOCALES.ROMANIA]: {
        code: exports.LOCALES.ROMANIA,
        fallback: 'Romania',
        fullSupport: true,
        hasApp: false,
        hasBrowserExtension: false,
        hasCountryLink: true,
        nativeName: 'Romania',
        hasGraduate: false,
        hasBeansId: false,
        hasKevelPromoBoxes: false,
        hasZendeskChat: false,
        htmlLang: 'ro-ro',
        isEnglishSpeaking: false,
        locale: 'ro',
        zendesk: DEFAULT_ZENDESK,
        currency: 'RON'
    },
    [exports.LOCALES.RUSSIA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Russia', code: exports.LOCALES.RUSSIA }),
    [exports.LOCALES.SAUDI_ARABIA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Saudi Arabia', code: exports.LOCALES.SAUDI_ARABIA }),
    [exports.LOCALES.SINGAPORE]: {
        code: exports.LOCALES.SINGAPORE,
        fallback: 'Singapore',
        fullSupport: true,
        hasApp: false,
        hasBrowserExtension: false,
        hasCountryLink: true,
        nativeName: 'Singapore',
        hasGraduate: false,
        hasBeansId: false,
        hasKevelPromoBoxes: false,
        hasZendeskChat: false,
        htmlLang: 'en-sg',
        isEnglishSpeaking: true,
        locale: DEFAULT_LOCALE,
        zendesk: DEFAULT_ZENDESK,
        currency: 'SGD'
    },
    [exports.LOCALES.SLOVAKIA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Slovakia', code: exports.LOCALES.SLOVAKIA, htmlLang: 'sk-sk' }),
    [exports.LOCALES.SLOVENIA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Slovenia', code: exports.LOCALES.SLOVENIA, htmlLang: 'sl-si' }),
    [exports.LOCALES.SOUTH_AFRICA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'South Africa', code: exports.LOCALES.SOUTH_AFRICA }),
    [exports.LOCALES.SOUTH_KOREA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'South Korea', code: exports.LOCALES.SOUTH_KOREA }),
    [exports.LOCALES.SPAIN]: {
        code: exports.LOCALES.SPAIN,
        fallback: 'Spain',
        fullSupport: true,
        hasApp: true,
        hasBrowserExtension: true,
        hasCountryLink: true,
        nativeName: 'España',
        hasGraduate: false,
        hasBeansId: false,
        hasKevelPromoBoxes: true,
        hasZendeskChat: false,
        htmlLang: 'es-es',
        isEnglishSpeaking: false,
        locale: 'es',
        zendesk: 'es',
        currency: 'EUR'
    },
    [exports.LOCALES.SRI_LANKA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Sri Lanka', code: exports.LOCALES.SRI_LANKA }),
    [exports.LOCALES.SWEDEN]: {
        code: exports.LOCALES.SWEDEN,
        fallback: 'Sweden',
        fullSupport: true,
        hasApp: true,
        hasBrowserExtension: true,
        hasCountryLink: true,
        nativeName: 'Sverige',
        hasGraduate: false,
        hasBeansId: false,
        hasKevelPromoBoxes: false,
        hasZendeskChat: false,
        htmlLang: 'sv-se',
        isEnglishSpeaking: false,
        locale: 'sv',
        zendesk: 'sv',
        currency: 'SEK'
    },
    [exports.LOCALES.SWITZERLAND]: {
        code: exports.LOCALES.SWITZERLAND,
        fallback: 'Switzerland',
        fullSupport: true,
        hasApp: false,
        hasBrowserExtension: false,
        hasCountryLink: true,
        nativeName: 'Switzerland',
        hasGraduate: false,
        hasBeansId: false,
        hasKevelPromoBoxes: false,
        hasZendeskChat: false,
        htmlLang: 'de-ch',
        isEnglishSpeaking: false,
        locale: 'de',
        zendesk: 'de',
        currency: 'CHF'
    },
    [exports.LOCALES.TAIWAN]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Taiwan', code: exports.LOCALES.TAIWAN }),
    [exports.LOCALES.TANZANIA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Tanzania', code: exports.LOCALES.TANZANIA }),
    [exports.LOCALES.THAILAND]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Thailand', code: exports.LOCALES.THAILAND }),
    [exports.LOCALES.TRINIDAD_AND_TOBAGO]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Trinidad and Tobago', code: exports.LOCALES.TRINIDAD_AND_TOBAGO }),
    [exports.LOCALES.TUNISIA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Tunisia', code: exports.LOCALES.TUNISIA }),
    [exports.LOCALES.TURKEY]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Turkey', code: exports.LOCALES.TURKEY }),
    [exports.LOCALES.UKRAINE]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Ukraine', code: exports.LOCALES.UKRAINE }),
    [exports.LOCALES.UNITED_ARAB_EMIRATES]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'United Arab Emirates', code: exports.LOCALES.UNITED_ARAB_EMIRATES }),
    [exports.LOCALES.UNITED_KINGDOM]: {
        code: exports.LOCALES.UNITED_KINGDOM,
        fallback: 'United Kingdom',
        fullSupport: true,
        hasApp: true,
        hasBrowserExtension: true,
        hasCountryLink: true,
        nativeName: 'United Kingdom',
        hasGraduate: true,
        hasBeansId: true,
        hasKevelPromoBoxes: true,
        hasZendeskChat: true,
        htmlLang: 'en-gb',
        isEnglishSpeaking: true,
        locale: 'en-GB',
        zendesk: DEFAULT_ZENDESK,
        currency: 'GBP'
    },
    [exports.LOCALES.UNITED_STATES]: {
        code: exports.LOCALES.UNITED_STATES,
        fallback: 'United States',
        fullSupport: true,
        hasApp: true,
        hasBrowserExtension: true,
        hasCountryLink: true,
        nativeName: 'United States',
        hasGraduate: true,
        hasBeansId: true,
        hasKevelPromoBoxes: true,
        hasZendeskChat: true,
        htmlLang: 'en-us',
        isEnglishSpeaking: true,
        locale: 'en-US',
        zendesk: 'en-us',
        currency: 'USD'
    },
    [exports.LOCALES.VENEZUELA]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Venezuela', code: exports.LOCALES.VENEZUELA }),
    [exports.LOCALES.VIETNAM]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Vietnam', code: exports.LOCALES.VIETNAM }),
    [exports.LOCALES.VIRGIN_ISLANDS_BRITISH]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Virgin Islands, British', code: exports.LOCALES.VIRGIN_ISLANDS_BRITISH }),
    [exports.LOCALES.ZIMBABWE]: Object.assign(Object.assign({}, DEFAULT_COUNTRY), { fallback: 'Zimbabwe', code: exports.LOCALES.ZIMBABWE }),
    default: DEFAULT_COUNTRY
};

const LANGUAGE_MAP = {
    // Non GB-English Speaking Countries
    uk: 'en-gb',
    au: 'en',
    ca: 'en',
    ie: 'en',
    nz: 'en',
    us: 'en-us',
    // Non English Speaking Countries
    at: 'de-at',
    be: 'nl-be',
    br: 'pt-br',
    cn: 'zh-cn',
    cz: 'cs-cz',
    dk: 'da-dk',
    de: 'de-de',
    es: 'es-es',
    fi: 'fi-fi',
    fr: 'fr-fr',
    hk: 'zh-hk',
    hr: 'hr-hr',
    hu: 'hu-hu',
    it: 'it-it',
    mx: 'es-mx',
    jp: 'ja-jp',
    nl: 'nl-nl',
    no: 'no-no',
    pl: 'pl-pl',
    pt: 'pt-pt',
    ro: 'ro-ro',
    ru: 'ru-ru',
    sk: 'sk-sk',
    si: 'sl-si',
    se: 'sv-se'
};
const DEFAULT_LANGUAGE = LANGUAGE_MAP['uk'];
/**
 * A list of valid country codes for use in legacy connect language overrides
 */
const VALID_LEGACY_COUNTRY_CODES = new Set(Object.keys(LANGUAGE_MAP));
const VALID_LANGUAGE_CODES = new Set(Object.values(LANGUAGE_MAP));

exports.APPLICATION_IDS = void 0;
(function (APPLICATION_IDS) {
    APPLICATION_IDS["studentbeans"] = "studentbeans";
    APPLICATION_IDS["gradbeans"] = "gradbeans";
    APPLICATION_IDS["beansidConnect"] = "connect";
    APPLICATION_IDS["beansidMarketplace"] = "beans_id_marketplace";
    APPLICATION_IDS["browser_extension"] = "browser_extension";
    APPLICATION_IDS["accounts"] = "accounts";
    APPLICATION_IDS["ios"] = "ios";
    APPLICATION_IDS["android"] = "android";
    APPLICATION_IDS["unknown"] = "unknown";
})(exports.APPLICATION_IDS || (exports.APPLICATION_IDS = {}));
const CONNECT_APP_ID_TYPES = {
    hosted: 'hosted',
    embedded: 'embedded',
    'hosted-app': 'hosted-app',
    'embedded-app': 'embedded-app'
};
const WEBSITE_APP_ID_TYPE = 'website';
exports.PAGE_TYPES = void 0;
(function (PAGE_TYPES) {
    PAGE_TYPES["ABOUT_PAGE"] = "about_page";
    PAGE_TYPES["ACCESSIBILITY_PAGE"] = "accessibility_page";
    PAGE_TYPES["ALL_DISCOUNTS_PAGE"] = "all_discounts_page";
    PAGE_TYPES["BRAND_PAGE"] = "brand_page";
    PAGE_TYPES["BRAND_LIST_PAGE"] = "brand_list_page";
    PAGE_TYPES["CAMPAIGN_PAGE"] = "campaign_page";
    PAGE_TYPES["CAMPAIGN_LIST_PAGE"] = "campaign_list_page";
    PAGE_TYPES["CATEGORY_PAGE"] = "category_page";
    PAGE_TYPES["CATEGORY_LIST_PAGE"] = "category_list_page";
    PAGE_TYPES["CCG_PAGE"] = "ccg_page";
    PAGE_TYPES["CCG_LIST_PAGE"] = "ccg_list_page";
    PAGE_TYPES["COLLECTION_PAGE"] = "collection_page";
    PAGE_TYPES["COLLECTION_LIST_PAGE"] = "collection_list_page";
    PAGE_TYPES["COUNTRY_SELECTION_PAGE"] = "country_selection_page";
    PAGE_TYPES["ERROR_PAGE"] = "error_page";
    PAGE_TYPES["HOME_PAGE"] = "home_page";
    PAGE_TYPES["IMPRESSUM_PAGE"] = "impressum_page";
    PAGE_TYPES["OFFER_LIST_PAGE"] = "offer_list_page";
    PAGE_TYPES["OFFER_PAGE"] = "offer_page";
    PAGE_TYPES["OTHER"] = "other";
    PAGE_TYPES["RECOMMENDED_PAGE"] = "recommended_page";
    PAGE_TYPES["TERMS_AND_CONDITIONS_PAGE"] = "terms_and_conditions_page";
    PAGE_TYPES["TRENDING_PAGE"] = "trending_page";
    PAGE_TYPES["INSTORE_OFFERS_PAGE"] = "instore_offers_page";
    PAGE_TYPES["UNSUBSCRIBE_PAGE"] = "unsubscribe_page";
})(exports.PAGE_TYPES || (exports.PAGE_TYPES = {}));

const SB_STANDARD_CONTEXT_SCHEMA = 'iglu:com.studentbeans/sb_standard_context/jsonschema/2-1-0';

const LOGGED_OUT_USER_DATA = {
    logged_in: false,
    is_verified: null,
    user_verified_ccgs: null
};
exports.CCGS = void 0;
(function (CCGS) {
    CCGS["STUDENT"] = "student";
    CCGS["GRADUATE"] = "graduate";
    CCGS["HEALTHCARE"] = "healthcare";
    CCGS["TEACHER"] = "teacher";
    CCGS["MILITARY"] = "military";
    CCGS["LOW_INCOME"] = "low-income";
    CCGS["FIRST_RESPONDER"] = "first-responder";
    CCGS["CHARITY_WORKER"] = "charity-worker";
    CCGS["DISABILITY"] = "disability";
    CCGS["PARENT"] = "parent";
})(exports.CCGS || (exports.CCGS = {}));
exports.VerificationStatus = void 0;
(function (VerificationStatus) {
    VerificationStatus["Active"] = "active";
    VerificationStatus["Expired"] = "expired";
    VerificationStatus["Pending"] = "pending";
})(exports.VerificationStatus || (exports.VerificationStatus = {}));

exports.CONNECT_APP_ID_TYPES = CONNECT_APP_ID_TYPES;
exports.COUNTRIES = COUNTRIES;
exports.DEFAULT_COUNTRY = DEFAULT_COUNTRY;
exports.DEFAULT_LANGUAGE = DEFAULT_LANGUAGE;
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
exports.LANGUAGE_MAP = LANGUAGE_MAP;
exports.LOGGED_OUT_USER_DATA = LOGGED_OUT_USER_DATA;
exports.SB_STANDARD_CONTEXT_SCHEMA = SB_STANDARD_CONTEXT_SCHEMA;
exports.VALID_LANGUAGE_CODES = VALID_LANGUAGE_CODES;
exports.VALID_LEGACY_COUNTRY_CODES = VALID_LEGACY_COUNTRY_CODES;
exports.WEBSITE_APP_ID_TYPE = WEBSITE_APP_ID_TYPE;
